import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import {
  IDatePickerStrings,
  TextField,
} from 'office-ui-fabric-react';
import moment from 'moment';
import Readonly from '../Readonly';
import ModalDatePicker from 'views/components/UI/ModalDatePicker';
import { dateFormats } from 'utils/dateFormats';
import { textFieldIconProps } from 'views/pages/MapPage/components/MapDateTimePicker/config';

const DateTimePicker = styled.div`
  display: flex;
`;


interface IProps extends ICellProps {
  onChange: (value: number) => void;
  value: any;
}

const TextInput = styled.input`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  box-sizing: border-box;
  outline: none;
  padding: 0 10px;
`;

const DayPickerStrings: IDatePickerStrings = {
  months: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],

  shortMonths: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Май',
    'Июн',
    'Июл',
    'Авг',
    'Сен',
    'Окт',
    'Ноя',
    'Дек',
  ],

  days: [
    'Воскресенье',
    'Понеделик',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ],

  shortDays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],

  isRequiredErrorMessage: 'Выберите дату',

  goToToday: 'Перейти к сегодня',
  prevMonthAriaLabel: 'Предыдущий месяц',
  nextMonthAriaLabel: 'Следующий месяц',
  prevYearAriaLabel: 'Следующий год',
  nextYearAriaLabel: 'Предыдущий год',
  closeButtonAriaLabel: 'Закрыть выбор даты',
};

const DateTimeCtrl: React.FC<IProps> = (props: IProps) => {
  const [isModalDatePickerOpen, setIsModalDatePickerOpen] = useState<boolean>(false);

  const onToggleModalDatePicker = useCallback(
      () => setIsModalDatePickerOpen((prevModalState) => !prevModalState),
      [],
    );

    const onSelectDateTimeInModal = (value: Date): void => {
        props.onChange && props.onChange(moment(value).unix())
      }

    return props.readonly ? (
    <Readonly>{moment.unix(+props.value).format(dateFormats.readableDateTime)}</Readonly>
  ) : (
    <>
      {
        isModalDatePickerOpen &&
        <ModalDatePicker
          selectedValue={props.value ? new Date(props.value * 1000) : new Date()}
          onCloseModal={onToggleModalDatePicker}
          onSelectDate={onSelectDateTimeInModal}
          onCancel={onToggleModalDatePicker}
        />
      }
      <DateTimePicker>
        <TextField
          onClick={() => onToggleModalDatePicker()}
          iconProps={textFieldIconProps}
          styles={{root: {width: '100%', border: 'none'}}}
          value={props.value ? moment.unix(+props.value).format(dateFormats.readableDateTime) : ''}
          readOnly
          borderless
        />
      </DateTimePicker>
    </>
  );
};

export default DateTimeCtrl;
